import axios from 'axios';
import {
  APP_SETTING_DELETE_PROJECT_VERSION_BEGIN,
  APP_SETTING_DELETE_PROJECT_VERSION_SUCCESS,
  APP_SETTING_DELETE_PROJECT_VERSION_FAILURE,
  APP_SETTING_DELETE_PROJECT_VERSION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function deleteProjectVersion(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_PROJECT_VERSION_BEGIN,
    });
    const { projectId, uuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}versions/project/${projectId}/version/${uuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_DELETE_PROJECT_VERSION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_PROJECT_VERSION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteProjectVersionError() {
  return {
    type: APP_SETTING_DELETE_PROJECT_VERSION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_PROJECT_VERSION_BEGIN:
      return {
        ...state,
        deleteProjectVersionPending: true,
        deleteProjectVersionError: null,
      };

    case APP_SETTING_DELETE_PROJECT_VERSION_SUCCESS:
      return {
        ...state,
        deleteProjectVersionPending: false,
        deleteProjectVersionError: null,
      };

    case APP_SETTING_DELETE_PROJECT_VERSION_FAILURE:
      return {
        ...state,
        deleteProjectVersionPending: false,
        deleteProjectVersionError: action.data.error,
      };

    case APP_SETTING_DELETE_PROJECT_VERSION_DISMISS_ERROR:
      return {
        ...state,
        deleteProjectVersionError: null,
      };

    default:
      return state;
  }
}
